import { SysConfig } from 'resources/sysConfig';

export const vahiConfig: SysConfig = {
    languages: ['en', 'et', 'lv', 'pl', 'ro', 'de', 'lt'],
    lng: 'et',
    fallbackLng: 'en',
    tenantRegistration: {
        terms: {
            urlEng: 'https://bidrento.com/{{lang}}/terms-and-conditions/',
            type: 'termsAndConditions',
        },
        extraTerms: null,
    },
    dashboardComponents: {
        DashboardLogo: {
            id: 'DashboardLogo',
            position: 0,
            visible_for: '*',
            except_user_emails: [],
        },
        NotificationsBlock: {
            position: 0,
            visible_for: '*',
            except_user_emails: [],
        },
        UnpaidInvoicesNoticeBlock: {
            position: 0,
            visible_for: '*',
            except_user_emails: [],
        },
        PzuInsuranceNoticeBlock: {
            position: 0,
            visible_for: '*',
            except_user_emails: [],
        },
        TipsAndTricksPinBlock: {
            position: 0,
            visible_for: '*',
            except_user_emails: [],
        },
        CO2Badge: {
            position: 0,
            visible_for: '*',
            except_user_emails: [],
        },
        InceptionDeviceBlock: {
            position: 0,
            visible_for: '*',
            except_user_emails: [],
        },
        LarvaDevicesWidgetBlock: {
            position: 0,
            visible_for: '*',
            except_user_emails: [],
        },
        OrderExtraServiceAndMaintenanceButtons: {
            position: 0,
            visible_for: null,
            except_user_emails: [],
        },
        ExtraServicesButtonsBlock: {
            position: 0,
            visible_for: null,
            except_user_emails: [],
        },
        OrderServiceButtonBlock: {
            position: 0,
            visible_for: '*',
            except_user_emails: [],
        },
        InvoicesListBlock: {
            position: 0,
            visible_for: '*',
            except_user_emails: [],
        },
        CO2OverviewChartBlock: {
            position: 0,
            visible_for: '*',
            except_user_emails: [],
        },
        TipsAndTricksListBlock: {
            position: 0,
            visible_for: '*',
            except_user_emails: [],
        },
    },
    larva: {
        showIfAvailable: true,
        alwaysAvailableForEmails: ['demo+99@bidrento.com'],
    },
    meterReading: {
        delete: {
            allowedInHours: 72,
        },
    },
    appType: 'vahi',
};
